import StyledButtonCard from "./components/StyledButtonCard";
import roundCurrency from "./utils/roundCurrency";
import getBestDeal from "@/utils/specific/getBestDeal";
import useI18n from "@/hooks/useI18n";

export default function ProductList({ products, countryCode }: { products: Product[]; countryCode: string }) {
  const { difference, indexOfBestDeal } = getBestDeal(products) || {};
  const { t } = useI18n();

  return products?.map(
    ({ price, period, trialPeriod, trialDuration, currency, productId, couponCode, listPrice }, id) => {
      return (
        <StyledButtonCard
          key={price}
          period={period as "week" | "month" | "year"}
          buttonLabel={t("pricing.subscribe")}
          currency={currency}
          save={id === indexOfBestDeal && difference}
          price={roundCurrency(price, currency)}
          trialPeriod={trialPeriod as "day" | "week" | "month"}
          trialDuration={trialDuration}
          countryCode={countryCode}
          productId={productId}
          couponCode={couponCode}
          listPrice={listPrice}
          index={id}
        />
      );
    }
  );
}
